<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Customers</h4>
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <preDatatableComponent
          :hideBranch="true"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addExportButton="false"
          :sendToExport="sendToExport"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity: 0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.user_id"
              >
                <td>{{ r.user_id }}</td>
                <td class="ws-nowrap">
                  {{ r.full_name }}
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td>{{ r.email }}</td>
                <td>{{ r.phone_number }}</td>
                <td v-if="r.is_blocked === '0'">
                  <span class="label bg-green-600">Unblock</span>
                </td>
                <td v-else>
                  <span class="label bg-warning">Block</span>
                </td>
                <td>{{ r.address }}</td>
                <td>${{ r.credit }}</td>
                <td
                  v-if="$_has_perm('view_customer_transaction')"
                  style="padding-left: 0px; padding-right: 5px"
                >
                  <a
                    style="color: #555"
                    tooltip="Customer transaction"
                    @click="customerTransaction(r.user_id, r.full_name)"
                  >
                    <i class="material-icons">swap_horiz</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    phone_number="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>
          <table class="table">
            <tr>
              <td style="width: 100%; padding-top: 5px">
                <span style="float: right; font-weight: bold; padding-right: 30px">Total income &nbsp; ${{ totalCredit }}</span>
              </td>
            </tr>
          </table>

          <!-- TODO show in mobile -->
          <mobile-datatable
            v-if="isMobile"
            :isCustomer="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  ID: {{ r.user_id }} , <br />
                  Name: {{ r.full_name }} , <br />
                  {{ r.email }} , <br />
                  {{ r.phone_number }}, <br />
                  {{ r.address }}
                </td>
                <td>
                  <span v-if="r.is_blocked === '0'">
                    <span class="label bg-green-600">Unblock</span>
                  </span>
                  <span v-else>
                    <span class="label bg-warning">Block</span>
                  </span>
                  ${{ r.credit }} <br />
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <customer-transactions
            :tranDialog="tranDialog"
            :customerId="customerId"
            :customerName="customerName"
            @close-dialog="tranDialog = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination'
import preDatatableComponent from '../preDatatableComponent'
import DatatableVue from '../Datatable'
import createUser from './createUser.vue'
import editCustomer from './editCustomer.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'
import customerTransactions from './customerTransactions.vue'

export default {
  components: {
    customerTransactions,
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'create-user': createUser,
    'edit-customer': editCustomer,
    'mobile-datatable': mobileDatatable,
  },
  created() {
    if (this.queryParameter === true) {
      if (
        window.location.search.replace('?name=', '') !== null ||
        window.location.search.replace('?name=', '') !== ''
      ) {
        let value = window.location.search.replace('?name=', '').replace(/%20/g, ' ')
        this.searchOneCol('full_name', value)
      }
    }
    this.getResults()
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      {
        label: 'ID',
        text: 'ID',
        value: '1',
        sortable: true,
        searchable: true,
        name: 'user_id',
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: 'Email',
        text: 'Email',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'email',
      },
      {
        label: 'Phone Number',
        text: 'Phone Number',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'phone_number',
      },
      {
        label: 'Status',
        text: 'Status',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'is_blocked',
      },
      {
        label: 'Address',
        text: 'Address',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'address',
      },
      {
        label: 'Credit',
        text: 'Credit',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'credit',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/loan_customers',
      tranDialog: false,
      customerName: '',
      the_user_id: '',
      alertValue: false,
      checkAlert: false,
      errorAlert: false,
      validationError: false,
      phoneError: false,
      editCustomerModal: false,
      backendError: false,
      emailError: '',
      phoneNumberError: '',
      btnsave: true,
      totalCredit: 0,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'user_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    sendToExport() {
      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/customer-export')
    },

    getResults(url = this.url) {
      let token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, {
          params: this.tableData,
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          let total = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            total = total + Number(this.apiResults[i].credit)
            this.totalResult += 1
          }
          this.totalCredit = total.toFixed(2)
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    customerTransaction(id, name) {
      this.customerName = name
      this.customerId = id
      this.tranDialog = true
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },
  },
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/loanedCustomers.vue